import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthProvider from './Auth';
import { OnlineProvider } from './Online';
import { WebCfgProvider } from './WebCfg';
import MainPage from './Pages/Main';
import { ApiProvider } from './Api';
import '@cloudscape-design/global-styles/index.css';
import Home from './Pages/Home';
import {PlaytestDemo, PlaytestPlaytest, PlaytestDevelopment} from './Pages/Playtest';
import Account from './Pages/Account';
import StakeAccount from './Pages/StakeAccount';
import FocusGroupSpike from './Pages/FocusGroupSpike';
import Test from './Pages/Test';


function App() {
  return (
    <BrowserRouter>
      <OnlineProvider>
        <WebCfgProvider>
          <AuthProvider>
            <ApiProvider> 
            <Routes>
              <Route path="/" element={<MainPage />}>
                <Route index element={<Home />} />  
                <Route path="Playtest" element={<PlaytestPlaytest/>} />
                <Route path="Development" element={<PlaytestDevelopment/>} />
                <Route path="Demo" element={<PlaytestDemo/>} />
                <Route path="StakeAccount" element={<StakeAccount />} />
                <Route path="FocusGroupSpike" element={<FocusGroupSpike />} />
                <Route path="Account" element={<Account />} />
                <Route path="Test" element={<Test />} />
              </Route>
            </Routes>
            </ApiProvider>
          </AuthProvider>
        </WebCfgProvider>
      </OnlineProvider>
    </BrowserRouter>
  );
}

export default App;
